<p-button
  [pTooltip]="tooltip"
  [tooltipOptions]="tooltipOptions" 
  [disabled]="disabled"
  (click)="click($event)"
  [label]="commandTemplate?.settings?.label"
  [styleClass]="getButtonClasses()"
  [iconPos]="iconPos"
  [ngClass]="getAdditionalClasses()">

  <!-- icon -->
  <ng-template
    pTemplate="icon">
    <i
      [ngClass]="commandTemplate?.settings?.icon">
    </i>
  </ng-template>
</p-button>  

